import { useAuth } from '@/features/auth/hooks/useAuth';

// AuthInit — null-mounting component that establishes the better-auth session subscription
// on app mount. Mirrors authClient.useSession() into useAuthStore via the useAuth hook.
// Pattern: same as ProjectInit — runs once on mount, returns null, never blocks rendering.
// Guest-first: if no session exists, the store stays in guestMode: true (default).
//
// IN-02: removed dead `initialized` ref and no-op useEffect — session subscription
// is fully handled by useAuth()'s own useEffect; the ref was never read by anything.
export const AuthInit = () => {
  useAuth();
  return null;
};
